/**
 * Sakura (application_id 84) のテーマカラー。桜 / pink 系。
 * base = pink-500 / 600、accent = rose-400 のグラデーション。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const SAKURA_PALETTE: ThemePalette = {
  appId: "84",
  appName: "Sakura",
  cyan: tw.pink,
  teal: tw.rose,
  gradient: { from: tw.pink[500], to: tw.rose[400] },
  ink: { base: "#2E0A1A", soft: "#7A3D55", mute: "#B58598" },
  app: { bg: "#FFF5F8", card: "#FFFFFF" },
};
